import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEWS } from "../data/pricing";

const Stars = ({ n }) => (
  <div className="flex gap-0.5" aria-label={`${n} stelle`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={15} className={i < n ? "text-[#A0E0FF] fill-[#A0E0FF]" : "text-slate-600"} />
    ))}
  </div>
);

export const Testimonials = () => {
  const avg = (REVIEWS.reduce((a, r) => a + r.rating, 0) / REVIEWS.length).toFixed(1);
  return (
    <section id="recensioni" data-testid="reviews-section" className="relative py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#7EC8E3] font-semibold">
            Recensioni
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mt-3">
            Cosa dicono <span className="text-metallic">i nostri clienti</span>
          </h2>
          <div data-testid="reviews-average" className="inline-flex items-center gap-3 mt-5 rounded-full bg-[#050B18]/70 border border-[#7EC8E3]/40 px-5 py-2">
            <span className="text-2xl font-extrabold text-metallic font-display">{avg}</span>
            <Stars n={5} />
            <span className="text-xs text-slate-400">{REVIEWS.length} recensioni</span>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {REVIEWS.map((r, i) => (
            <motion.figure
              key={r.id}
              data-testid={`review-card-${r.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="card-metallic rounded-2xl p-6 flex flex-col"
            >
              <Quote size={22} className="text-[#7EC8E3]/60" />
              <blockquote className="text-sm text-slate-200 leading-relaxed mt-3 flex-1">“{r.text}”</blockquote>
              <div className="mt-5">
                <Stars n={r.rating} />
                <div className="font-bold text-slate-100 mt-2">{r.name}</div>
                <div className="text-xs text-slate-400">{r.city} · {r.car}</div>
              </div>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
